import groupimage1 from '@/assets/groupimage1.jpg'
import groupimage2 from '@/assets/groupimage2.jpg'
import groupimage3 from '@/assets/groupimage3.jpg'
import groupimage4 from '@/assets/groupimage4.jpg'
import groupimage5 from '@/assets/groupimage5.jpg'

export default {

  slides: [
    {
      type: 'title',
      title: 'Candy Codes',
      image: groupimage1,
      text: 'Principles of parenting explained through programming.',
    },
    {
      type: 'group',
      groupid: 1,
      image: groupimage1,
      title: 'There is an Apple and a Candy on the table.',

    },
    {
      type: 'lesson',
      title: 'Lesson 1 — A Command',
      assignment: 'Eat the Apple.',
      posterImageUrl: groupimage1,
      videoUrls: {
        1080: 'https://player.vimeo.com/external/247828048.hd.mp4?s=fb8b1bb2531a267fa4905606bda564b947ff7d66&profile_id=175',
        720: 'https://player.vimeo.com/external/247828048.hd.mp4?s=fb8b1bb2531a267fa4905606bda564b947ff7d66&profile_id=174',
        540: 'https://player.vimeo.com/external/247828048.sd.mp4?s=930acf2fa7a0c2f9435e9ae57ba406f8773cd4dc&profile_id=165',
        360: 'https://player.vimeo.com/external/247828048.sd.mp4?s=930acf2fa7a0c2f9435e9ae57ba406f8773cd4dc&profile_id=164',
      },
    },
    {
      type: 'lesson',
      title: 'Lesson 2 — Simple program',
      assignment: 'Eat the Apple.<br>^500Eat the Candy.',
      posterImageUrl: groupimage1,
      videoUrls: {
        1080: 'https://player.vimeo.com/external/247828003.hd.mp4?s=bcf2dc5dd4dc0af45d8534fd8c432e34e3570b8d&profile_id=175',
        720: 'https://player.vimeo.com/external/247828003.hd.mp4?s=bcf2dc5dd4dc0af45d8534fd8c432e34e3570b8d&profile_id=174',
        540: 'https://player.vimeo.com/external/247828003.sd.mp4?s=2468beab0abd522cc15e6b6537cc6e11c60805e2&profile_id=165',
        360: 'https://player.vimeo.com/external/247828003.sd.mp4?s=2468beab0abd522cc15e6b6537cc6e11c60805e2&profile_id=164',
      } },
    {
      type: 'lesson',
      title: 'Lesson 3 — Conditions',
      assignment: 'Eat the Apple.<br><span class="typo-underline">^500If</span> Apple is eaten:<br><span class="indented-3">^500Eat the Candy.</span>',
      posterImageUrl: groupimage1,
      videoUrls: {
        1080: 'https://player.vimeo.com/external/247955577.hd.mp4?s=eae493f85e40bf58185893bc728232e7c1c7ab40&profile_id=175',
        720: 'https://player.vimeo.com/external/247955577.hd.mp4?s=eae493f85e40bf58185893bc728232e7c1c7ab40&profile_id=174',
        540: 'https://player.vimeo.com/external/247955577.sd.mp4?s=d1e2aec39a9183b2b4560a2b9489cb1af8a65151&profile_id=165',
        360: 'https://player.vimeo.com/external/247955577.sd.mp4?s=d1e2aec39a9183b2b4560a2b9489cb1af8a65151&profile_id=164',
      } },
    {
      type: 'group',
      groupid: 2,
      image: groupimage2,
      title: 'There is an Apple, a Pear and the Candy on the table.',
    },
    {
      type: 'lesson',
      title: 'Lesson 4 — Operator “And”',
      assignment: 'Eat the Apple.<br>^500Eat the Pear.<br>^500If the Apple <span class="typo-underline">and</span> the Pear are eaten:<br><span class="indented-3">^500Eat the Candy.</span>',
      posterImageUrl: groupimage2,
      videoUrls: {
        1080: 'https://player.vimeo.com/external/247827913.hd.mp4?s=6d11d9b7ee2b42f4e950c65f3351d4ac52167846&profile_id=175',
        720: 'https://player.vimeo.com/external/247827913.hd.mp4?s=6d11d9b7ee2b42f4e950c65f3351d4ac52167846&profile_id=174',
        540: 'https://player.vimeo.com/external/247827913.sd.mp4?s=774ddeaba4daa5137aee02bf91f2a02d55c21263&profile_id=165',
        360: 'https://player.vimeo.com/external/247827913.sd.mp4?s=774ddeaba4daa5137aee02bf91f2a02d55c21263&profile_id=164',
      } },
    {
      type: 'lesson',
      title: 'Lesson 5 — Operator “Or”',
      assignment: 'Eat the Pear.<br>^500If the Apple <span class="typo-underline">or</span> the Pear is eaten: <span class="indented-3">^500Eat the Candy.</span>',
      posterImageUrl: groupimage2,
      videoUrls: {
        1080: 'https://player.vimeo.com/external/247827980.hd.mp4?s=48e382b78505f2315d1351b830289ef8189f798f&profile_id=175',
        720: 'https://player.vimeo.com/external/247827980.hd.mp4?s=48e382b78505f2315d1351b830289ef8189f798f&profile_id=174',
        540: 'https://player.vimeo.com/external/247827980.sd.mp4?s=fd2f8dfba121c0d244a6cf9ed53e861a30dbbdfc&profile_id=165',
        360: 'https://player.vimeo.com/external/247827980.sd.mp4?s=fd2f8dfba121c0d244a6cf9ed53e861a30dbbdfc&profile_id=164',
      } },
    {
      type: 'group',
      groupid: 3,
      image: groupimage3,
      title: 'There are three Apples and the Candy on the table.',
    },
    {
      type: 'lesson',
      title: 'Lesson 6 — Loop',
      assignment: 'Eat 3 times an Apple.<br>^500Eat the Candy.',
      posterImageUrl: groupimage3,
      videoUrls: {
        1080: 'https://player.vimeo.com/external/247955599.hd.mp4?s=5caeb321e6934361851cc29176644a74740a57ca&profile_id=175',
        720: 'https://player.vimeo.com/external/247955599.hd.mp4?s=5caeb321e6934361851cc29176644a74740a57ca&profile_id=174',
        540: 'https://player.vimeo.com/external/247955599.sd.mp4?s=111a9e4227260326befe39834e90c1b5f2aa4c42&profile_id=165',
        360: 'https://player.vimeo.com/external/247955599.sd.mp4?s=111a9e4227260326befe39834e90c1b5f2aa4c42&profile_id=164',
      } },
    {
      type: 'group',
      groupid: 4,
      image: groupimage4,
      title: 'There are three Apples and the Candy on the table.',
    },
    {
      type: 'lesson',
      title: 'Lesson 7 — While loop',
      assignment: 'While not all the Apples are eaten:<br><span class="indented-3">^500Eat an Apple.</span><br>^500Eat the Candy.',
      posterImageUrl: groupimage4,
      videoUrls: {
        1080: 'https://player.vimeo.com/external/247827857.hd.mp4?s=a8b40075c4f85605dbbbafdd9b6089029ae6a1d3&profile_id=175',
        720: 'https://player.vimeo.com/external/247827857.hd.mp4?s=a8b40075c4f85605dbbbafdd9b6089029ae6a1d3&profile_id=174',
        540: 'https://player.vimeo.com/external/247827857.sd.mp4?s=ad65885fa5edff13edaaf934e63bfd0413265866&profile_id=165',
        360: 'https://player.vimeo.com/external/247827857.sd.mp4?s=ad65885fa5edff13edaaf934e63bfd0413265866&profile_id=164',
      } },
    {
      type: 'lesson',
      title: 'Lesson 8 — Function',
      assignment: 'The following we will call from now on ‘the harsh reality’<br><br>^500While not all the Apples are eaten:<br><span class="indented-3">^500Eat an Apple.</span><br>^500Eat the Candy.<br><br>^500Execute ‘the harsh reality’',
      posterImageUrl: groupimage4,
      videoUrls: {
        1080: 'https://player.vimeo.com/external/247827810.hd.mp4?s=830bb73742256e197b9b6386e3585266de0efd48&profile_id=175',
        720: 'https://player.vimeo.com/external/247827810.hd.mp4?s=830bb73742256e197b9b6386e3585266de0efd48&profile_id=174',
        540: 'https://player.vimeo.com/external/247827810.sd.mp4?s=5be879b5910ec8fe5acb8316ef21f3cbaf5815c3&profile_id=165',
        360: 'https://player.vimeo.com/external/247827810.sd.mp4?s=5be879b5910ec8fe5acb8316ef21f3cbaf5815c3&profile_id=164',
      } },
    {
      type: 'group',
      groupid: 5,
      image: groupimage5,
      title: 'There is an unknown amount of Apples on the table, it’s your child’s birthday and he or she received a pile of Candy.',
    },
    {
      type: 'lesson',
      title: 'Lesson 9 — A function with a condition',
      assignment: 'The following we call from now on ‘the anniversary reality’:<br><br><span class="indented-1">^500While not all the Candy is eaten:</span><span class="indented-3">^500Eat a Candy.</span><br>^500If today is your birthday execute ‘the anniversary reality’.<br><span class="indented-1">^500Otherwise execute ‘the harsh  reality’</span>',
      posterImageUrl: groupimage5,
      videoUrls: {
        1080: 'https://player.vimeo.com/external/247827767.hd.mp4?s=a31ec355f493eaf9c1eb36287e194d4c43dbce9a&profile_id=175',
        720: 'https://player.vimeo.com/external/247827767.hd.mp4?s=a31ec355f493eaf9c1eb36287e194d4c43dbce9a&profile_id=174',
        540: 'https://player.vimeo.com/external/247827767.sd.mp4?s=48a4a54099ff46d54214c7fc6212c719d77c419f&profile_id=165',
        360: 'https://player.vimeo.com/external/247827767.sd.mp4?s=48a4a54099ff46d54214c7fc6212c719d77c419f&profile_id=164',
      } },
  ],

}



// WEBPACK FOOTER //
// ./src/constants/copy.js